import * as React from "react";

const Separator = React.forwardRef(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => (
    <div
      ref={ref}
      role={decorative ? "separator" : undefined}
      aria-orientation={orientation}
      className={
        "shrink-0 bg-border " +
        (orientation === "horizontal"
          ? "h-px w-full "
          : "h-full w-px ") +
        (className || "")
      }
      {...props}
    />
  )
);
Separator.displayName = "Separator";

export { Separator };
